import { useCallback, useContext } from 'react'
import { com } from '@eidu/form'
import useEntityRepository from './useEntityRepository'
import { EntityTypesContext } from './context/EntityTypes'
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import EntityId = com.eidu.sharedlib.entity.EntityId
import EntityType = com.eidu.sharedlib.entity.type.EntityType

const useEntityFetcher = () => {
  const entityTypesRepo = useContext(EntityTypesContext)
  const types = entityTypesRepo.useAll() || new Map<EntityTypeId, EntityType>()

  const repo = useEntityRepository({ typeId: undefined, types, pageSize: 1 }, [
    JSON.stringify([...types.keys()].map((it) => it.toString())),
  ])

  return useCallback((id: EntityId) => repo.get(id), [repo])
}

export default useEntityFetcher
